export default {
  // ========== Tooltips ==========
  clearContent: 'Limpiar Contenido',

  // ========== Títulos de modales ==========
  createTitle: 'Crear título',
  editTitle: 'Editar título',

  // ========== Formulario ==========
  title: 'Título',
  default: 'Predeterminado',
  saveTitle: 'Guardar Título',

  // ========== Botones ==========
  addDescriptor: 'Agregar Descriptor',
  attachments: 'Anexos',

  // ========== Textos informativos ==========
  descriptionOf: 'Descripción de la',
  hiddenInNormalView: 'Oculto en vista normal',

  // ========== Confirmaciones ==========
  editDescriptorConfirm: '¿Está seguro de que desea editar el Descriptor?',
  affectOthersWarning: 'Esto podria afectar a otros {entity}!',
  necessaryObjectWarning: 'Este objeto es necesario para el funcionamiento de la maleta didáctica.',

  // ========== Copiar Descriptores ==========
  copyDescriptorsToEpm: 'Copiar a la {entity} de otro {entity2}',
  copyDescriptorsFromEpm: 'Copiar desde la {entity} de otro {entity2}',
  copyDescriptorsToMatter: 'Copiar hacia {entityMatter}',
  copyDescriptorsFromMatter: 'Copiar desde {entityMatter}',
  copyDescriptors: 'Copiar Descriptores',
  copyDescriptorsConfirm: '¿Está seguro de que desea copiar los descriptores? Los descriptores actuales del destino serán eliminados y reemplazados. Esta acción no podrá revertirse.',
  copyDescriptorsSuccess: 'Descriptores copiados correctamente.',
  copyDescriptorsError: 'Se ha producido un error al copiar los descriptores.',
  copyEpmToEpmDescriptorsDesc: 'Los descriptores de esta {entity} se copiarán hacia la {entity} del otro {entityProfile} de destino que selecciones. Los descriptores actuales del destino serán eliminados y reemplazados por los de esta {entity}. <strong>Requisito:</strong> ambas {entity} deben tener la opción "Vincular Asignatura Base" en <strong>No</strong>.',
  copyEpmFromEpmDescriptorsDesc: 'Los descriptores de la {entity} de origen seleccionada se copiarán hacia esta {entity}. Los descriptores actuales de esta {entity} serán eliminados y reemplazados. <strong>Requisito:</strong> ambas {entity} deben tener la opción "Vincular Asignatura Base" en <strong>No</strong>.',
  copyEpmToMatterDescriptorsDesc: 'Los descriptores de esta {entity} se copiarán hacia la {entityMatter} base. Esto afectará a todas las {entityEpm} que están vinculadas a esta {entityMatter}.',
  copyMatterToEpmDescriptorsDesc: 'Los descriptores de la {entityMatter} base se copiarán hacia esta {entity}, reemplazando los descriptores actuales.',
  descriptorsToBecopied: 'Descriptores a copiar',
  descriptorsToBeReplaced: 'Descriptores que se reemplazarán',
  noDescriptorsInSource: 'Sin descriptores en el origen.',
  noDescriptorsInTarget: 'Sin descriptores en el destino.',
  loadingDescriptors: 'Cargando descriptores...',
  noContent: 'Sin contenido',
  sourceLabel: 'Origen',
  targetLabel: 'Destino',
  selectTargetEpm: 'Seleccione la {entity} de destino',
  selectSourceEpm: 'Seleccione la {entity} de origen',
  sectionTop: 'Descriptores de la parte superior.',
  sectionBottom: 'Descriptores de la parte inferior.',
  sectionMiddle: 'Descriptores entre los resultados de aprendizaje y las evaluaciones.',
  sectionAfterEvaluations: 'Descriptores después de las evaluaciones.',
  sectionAfterLearningEnv: 'Descriptores después de los recursos del ambiente de aprendizaje.',

  // ========== Ordenar Descriptores ==========
  dropZoneHint: 'Arrastre aquí un descriptor de otra sección',
}
